export default __webpack_public_path__ + "static/media/dashboard.cb9488db.svg";